module.exports = "/images/icon-deposit.png?e8eb3897e8fc76579274e200bca84955";